import Email from "../components/email"
export const inicio =
<div>
<p>
    ¡Hola!, bienvenido a mi website. Te cuento un poco acerca de mí y de este sitio:
</p>
<p>
    Tengo alma de programador de computadores, procuro dar mi mejor aporte al mundo desde mi estrecho grado de conocimiento. 
    En este website encontrarás mi recorrido e intereses laborales y personales.
</p>
<p>
    Quería hace tiempo escribir acerca de muchas cosas de la vida, aprovecho este espacio para plasmar esas ideas. Encontrarás una sección de
    artículos de opinión de los que me gustaría que conozcas mi perspectiva. También conoceras otros escritos acerca de vivencias personales.
    {/* Próximamente iniciaré algunos escritos literarios en los que he pensado aventurarme. */}
</p>
<p>
    Espero que disfrutes este espacio, si te interesa: trabajar conmigo, compartir pasatiempos, debatir acerca de los temas que escribo o desorrollar
    un poco más las ideas que planteo; no dudes en contactarme a: 
</p>
<p>
    <Email email="nicolas.barajas@gmail.com"></Email>
</p>
<p>
    También te invito a seguirme en las redes sociales para que estés al tanto de mis publicaciones:
</p>
<p>
    <a href="https://www.facebook.com/nicolas.barajas.mora" target="_blank" rel="noreferrer">Facebook</a>
    <br/>
    <a href="https://www.twitter.com/NicoBarajasMora" target="_blank" rel="noreferrer">Twitter</a>
</p>
</div>
